import React from 'react';
import { withProps } from 'recompose';
import cx from 'classnames';

import TextEditorToolCaret from '../../components/toolbar/TextEditorToolCaret';
import styles from './withRichTextSelectToolStyles.scss';

export default withProps(({ className }) => ({
  className: cx(className, styles.tool, styles.up),
  portalMenuWrapperClassName: cx(className, styles.tool, styles.up),
  renderArrow: () => <TextEditorToolCaret />,
}));
